import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getDocumentOrganization } from "./documents.thunks";
import { OrganizationCardResponse } from "libs/apiClient/data-contracts";

interface DocumentsState {
	searchValue: string;
	documentOrganization: OrganizationCardResponse | null;
}

const initialState: DocumentsState = {
	searchValue: "",
	documentOrganization: null,
};

const documentsSlice = createSlice({
	name: "documentsSlice",
	initialState,
	reducers: {
		ChangeSearchValue(state, action: PayloadAction<string>) {
			state.searchValue = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(getDocumentOrganization.fulfilled, (state, action) => {
			state.documentOrganization = action.payload;
		});
	},
});

export const { ChangeSearchValue } = documentsSlice.actions;
export default documentsSlice.reducer;
